<style scoped>
.container {
  display: flex;

  margin: 20px;
}

.novel-info {
  display: flex;
  width: 200px;
  flex-direction: column;
  align-items: flex-start;
  background-color: #2c3e50;
  margin-left: 30px;
}



.novel-info h2 {
  font-size: 24px;
  margin-bottom: 10px;
}

.novel-info p {
  margin-bottom: 20px;
}

.rating {
  display: flex;
  align-items: center;
  font-size: 16px;
}

.rating span {
  margin-right: 5px;
}
</style>


<template>

  <el-button @click="cha">添加章节</el-button>
  <el-button @click="l">编辑章节</el-button>
  <div class="container">

      <div class="novel-info">
        <el-image
            style="width:200px; height: 220px"
            :src="'http://hsq.org.cn:8090/hsq/file/' + novel.cover"
        />

      </div>
    <table style="margin-left: 10px;text-align: left">
      <tr>
        <td>小说名:</td>
        <td>{{ novel.title }}</td>
      </tr>
      <tr>
        <td>作者:</td>
        <td>{{ novel.username }}</td>
      </tr>
      <tr>
        <td>类型:</td>
        <td>{{ novel.type }}</td>
      </tr>
      <tr>
        <td>简介:</td>
        <td>{{ novel.description }}</td>
      </tr>
      <tr>
        <td>评分:</td>
        <td>
          <el-rate v-model="value" disabled show-score text-color="#ff9900" score-template="{value} points"></el-rate>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>
          <el-popover :visible="visible" placement="top" :width="160">
            <div style="text-align: center; margin: 0">
              <el-rate v-model="value1" />
              <el-button size="small" text @click="visible = false">取消</el-button>
              <el-button size="small" type="primary" @click="userRating">确认</el-button>
            </div>
            <template #reference>
              <el-button @click="visible = true">读者评分</el-button>
            </template>
          </el-popover>
        </td>
      </tr>
    </table>





  </div>
  <div class="chapter-list" style="text-align: left">
    <h3>章节列表：</h3>

    <ul>
      <div v-for="novelchapter in novelchapters" :key="novelchapter.chapter">
        <el-button @click="chakan(novelchapter)">第{{novelchapter.chapter}}章{{novelchapter.chaptername}}</el-button>
      </div>
    </ul>
  </div>


  <el-dialog v-model="showDialog" title="添加数据">
    <div>

      <el-form :model="arrs">
        <el-form-item label="章节">
        第{{arrs.chapter}}章
        </el-form-item>
        <el-form-item label="章节标题">
          <el-input v-model="arrs.chapter_name" :rules="[{ required: true, message: '请输入章节标题', trigger: 'blur' }]"></el-input>
        </el-form-item>
        <el-form-item label="章节内容">

          <div id="editor" style="text-align: left"></div>
          <el-button type="primary"  :disabled="isTitleEmpty" @click="add">添加章节</el-button>
        </el-form-item>
      </el-form>

    </div>
  </el-dialog>
</template>

<script>

import request from "@/utils/request";
import axios from "axios";
import router from "@/router";
import E from 'wangeditor'
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Novelchapters",

  data(){
    let novelid=this.$route.query.id
    return{
      editor:null,
      arrs:{},
      novelid:novelid,
      user:localStorage.getItem('user')?JSON.parse(localStorage.getItem('user')):{},
      params: {
        title: "",
        username:"",
        uid:"",
        chapter:"",
        pageNum:1,
        pageSize:1000,
      },
      chapters:{
        title: "",
        chapter:"",
        chaptername:"",
        isVisible:"false"
      },
      items:[],
      txt:"",
      showDialog:false,
      novel:"",
      value:4.2,
      novelchapters:[],
      visible:false,
      value1:0

    }
  },
  methods:{
    initWangEditor(content) {

      this.$nextTick(() => {
        this.editor = new E('#editor')//在id为editor的地方去初始化一个富文本编辑器出来
        this.editor.config.placeholder = '请输入内容'//内容为空时候的提示语
        this.editor.config.uploadFileName = 'file'//接收文件叫file(与FileController里面参数名字必须一致)
        this.editor.config.uploadImgServer = 'http://hsq.org.cn:8090/hsq/file/wang/upload'//后台端口号
        this.editor.create()
        setTimeout(() => {
          this.editor.txt.html(content)
        })
      })
    },
    init(){
    request.post("novel/select/"+this.novelid).then(res=>{
       var item=res.data;
      this.arrs=item;
      this.novel=item;
      this.params.title=item.title;
      this.params.uid=item.uid;
      request.post("/rating/get",this.novel).then(res=>{
        if(res.code=="1"&res.data!=null) {
          this.value = res.data.rating
        }


      })


      // 使用传递的数据进行处理
      request.get('/novelchapter/get', {params: this.params}).then(res => {

        if (res.code === '1') {
          this.novelchapters=res.data.list



        }
        else{
          this.$message({
            message: res.msg,
            type: 'error'
          });
        }
      })
    })





    },
    cha(){

      this.showDialog=true;
      if(this.editor==null){
      this.initWangEditor('')}//初始化富文本编辑器
      request.get('/novelchapter/get',{params:this.params}).then(res=>{

        if (res.code === '1') {
          this.items = res.data.list;

          if(this.items.length!=0) {
            const idArray = this.items.map(obj => obj.chapter);
            const maxchapter = Math.max(...idArray);
            this.arrs.chapter=maxchapter+1;
          }else{
            this.arrs.chapter=1;
          }
        } else {
          this.$message({
            message:res.msg,
            type: 'error'
          });
        }

      })

    },
    add(){
      this.chapters.uid=this.user.id
      this.chapters.title=this.arrs.title
      this.chapters.chapter=this.arrs.chapter
      this.chapters.chaptername=this.arrs.chapter_name
      this.chapters.username=null
      this.arrs.content=this.editor.txt.html()
      request.post('/novelchapter/save',this.chapters);
      request.post("/file/novelupload",this.arrs).then(res=>{
        if(res.code=="1"){
          this.$message({
            message: "添加成功",
            type: 'success'
          });
          this.init();
        }else{
          this.$message({
            message: res.msg,
            type: 'error'
          });
        }
      })
   this.arrs.chapter="";
      this.arrs.chapter_name="";
      this.arrs.content="";
      this.showDialog=false;
    },
    chakan(novelchapter){

      novelchapter.chapter_name=novelchapter.chaptername
      request.post("/file/novelupload/novelchapter",novelchapter).then(res=>{
          this.txt = res.data;
        localStorage.setItem('chaptercontent', JSON.stringify(res.data));
        localStorage.setItem('chapterId', novelchapter.id);
        router.push("/novelcontent")

      })

    },

    l(){
      axios.get("https://api.vvhan.com/api/view?type=json").then(res=>{
        console.log(res.data.imgurl)
      })
    },
    userRating(){
      this.visible = false;
      const rating={
        nid:this.novel.id,
        uid:this.user.id,
        rating:this.value1,
      }
      request.post("rating/save",rating)
    }

  },

  mounted() {

this.init();

      }


}
</script>